var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('dropped-order-banner',{attrs:{"show":_vm.showDroppedOrderBanner,"timerEnd":_vm.timerEnd,"hotelInfo":_vm.hotelInfo,"link":_vm.link}})
}
var staticRenderFns = []

export { render, staticRenderFns }